import { render, staticRenderFns } from "./GroupDashboard.vue?vue&type=template&id=745682f2"
import script from "./GroupDashboard.vue?vue&type=script&lang=js"
export * from "./GroupDashboard.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/main_group_dashboard.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports